module.exports = __webpack_public_path__ + "img/lawkv.a47e6444.png";